import RequestStatus from "./RequestStatus";
import CurrencyItem from "./CurrencyItem";

export enum FeeType {
    FixedClosingFee = 'FixedClosingFee',
    ReferralFee = 'ReferralFee',
    VariableClosingFee = 'VariableClosingFee',
    FulfillmentFee = 'FulfillmentFee',
    BubblewrapFee = 'BubblewrapFee',
    PolybaggingFee = 'PolybaggingFee',
    LabelingFee = 'LabelingFee',
    OpaqueBaggingFee = 'OpaqueBaggingFee',
    TapingFee = 'TapingFee',
    FBAInboundConvenienceFee = 'FBAInboundConvenienceFee'
}

export interface ProgramFees {
    readonly countryCode: string;
    readonly merchantId: string;
    readonly asin: string;
    readonly fnsku: string;
    readonly programFeeResultMap: Record<string, ProgramFeeResult>; // program name -> program fee
}

export interface ProgramFeeResult {
    readonly otherCost?: OtherCost;
    readonly perUnitPeakStorageFee?: FeeInfo;
    readonly perUnitNonPeakStorageFee?: FeeInfo;
    readonly otherFeeInfoMap: Record<string, FeeInfo>; // fee type name -> fee
}

export interface OtherCost {
    readonly vatRate?: number;
    readonly vatAmount?: CurrencyItem;
    readonly ifdRate?: number;
    readonly ifdAmount?: CurrencyItem;
}

export interface FeeInfo {
    readonly feeAmount: CurrencyItem;
    readonly promotionAmount: CurrencyItem;
    readonly taxAmount: CurrencyItem;
    readonly total: CurrencyItem;
    readonly id: string;
    readonly feeNameStringId: string;
    readonly timeOfFeesEstimate: number;
    readonly componentFees: Array<FeeInfo>;
}

export interface ProgramFeesResponse { // used in saga
    readonly succeed: boolean;
    readonly data: ProgramFees;
}

export interface ProgramFeesStore {
    readonly countryCode: string;
    readonly merchantId: string;
    readonly asin: string;
    readonly fnsku: string;
    readonly programFeeResultWithStatusMap: Record<string, ProgramFeeResultWithStatus>; // program name -> program fee
}

export interface ProgramFeeResultWithStatus {
    readonly requestStatus: RequestStatus;
    readonly programFeeResult: any; // ProgramFeeResult or null;
}

export interface GetProgramFeesResponse { // used in reducer
    readonly requestStatus: RequestStatus;
    readonly programFeesStore: any; // ProgramFeesStore or null
}

export interface GetReportResponse { // used in reducer
    readonly requestStatus: RequestStatus;
    readonly report: any; // Array<Array<string>> or null
}

export interface ProgramParam {
    readonly marketplace: string;
    readonly inventoryPlace: string;
    readonly cee?: boolean;
}

export default GetProgramFeesResponse;
